module.exports = __webpack_public_path__ + "img/HQ-Z7030-V2-All.aad6cf25.jpg";